import React from 'react';
import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import Typography from '@mui/material/Typography';

export interface SpinProps {
  spinning?: boolean;
  tip?: string;
  size?: 'small' | 'default' | 'large';
  style?: React.CSSProperties;
  className?: string;
  children?: React.ReactNode;
  delay?: number;
  indicator?: React.ReactNode;
  [key: string]: any;
}

function progressSize(size?: SpinProps['size']) {
  if (size === 'small') return 20;
  if (size === 'large') return 48;
  return 32;
}

export const Spin: React.FC<SpinProps> = ({
  spinning = true,
  tip,
  size,
  style,
  className,
  children,
  indicator,
  delay,
  ...rest
}) => {
  void indicator;
  void delay;
  void rest;
  if (!children) {
    return spinning ? (
      <Box className={className} sx={{ display: 'inline-flex', alignItems: 'center', gap: 1, ...style }}>
        <CircularProgress size={progressSize(size)} />
        {tip && <Typography variant="body2">{tip}</Typography>}
      </Box>
    ) : null;
  }

  return (
    <Box className={['ant-spin-nested-loading', className].filter(Boolean).join(' ')} sx={{ position: 'relative', width: '100%', ...style }}>
      {children}
      {spinning && (
        <Box
          className="ant-spin-container"
          sx={{
            position: 'absolute',
            inset: 0,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            bgcolor: 'rgba(255,255,255,0.65)',
            zIndex: 10,
          }}
        >
          <CircularProgress size={progressSize(size)} />
          {tip && (
            <Typography variant="body2" sx={{ mt: 1 }}>
              {tip}
            </Typography>
          )}
        </Box>
      )}
    </Box>
  );
};

export default Spin;
